var VrRelatedCatalog = function() {
    var _this = this,
        _selectedBrandsArr = [],
        _visibleBrochureSelector = $(".vr-none:visible"),
        _visibleBrochuresLength = _visibleBrochureSelector.length,
        _allBrochureSelector,
        _numberOfAddBrochures,
        _visibleBrochureIds = [],
        _isXSmallResolution = window.matchMedia("(max-width: 768px)"),
        _gaEventCategory = '';
    
    var isViewPage = page_name == 'brochure_view',
        isBrandCityPage = page_name == 'brand_city';


    if(isViewPage){
        _gaEventCategory = 'brochure-view-';
    }else if(isBrandCityPage){
        _gaEventCategory = 'brand-city-clicks-';
    }

    _gaEventCategory +=  (isMobile ? 'mobile' : 'desktop');


    function _initSlider() {
        if (!isMobile && $(".vr-related-bottom .swiper-container").length > 0) {
            swiper = new Swiper('.vr-related-bottom .swiper-container', {
                slidesPerView: 5,
                slidesPerGroup: 1,
                navigation: {
                    nextEl: '.vr-related-bottom .swiper-button-next',
                    prevEl: '.vr-related-bottom .swiper-button-prev',
                },
                breakpoints: {
                    /*1800: {
                        slidesPerView: 6
                    },
                    1540: {
                        slidesPerView: 5
                    },
                    1290: {
                        slidesPerView: 4,
                        spaceBetween: 0,
                    },
                    1000: {
                        slidesPerView: 3
                    }*/
                    1270: {
                        slidesPerView: 4
                    },
                    1000: {
                        slidesPerView: 3
                    }
                },
                on: {
                    reachEnd: function() {
                        _showMoreBrochures()
                    }
                }
            });

            if ($(".swiper-container").innerWidth() > $(".swiper-slide").innerWidth() * 4) {
                //swiper.destroy(false,true);
            }
        } else {
            $(".vr-related-bottom .vr-none").removeClass("swiper-slide").addClass("col-xs-6");
            $(".vr-related-bottom .vr-sc").removeClass("swiper-container");
            $(".vr-related-bottom .vr-sw").removeClass("swiper-wrapper").addClass("col-xs-12");
        }
        // console.log("pod 768px res  : " + _isXSmallResolution.matches);
    }

    function _loadBrochuresInSlider() {

    }

    function _changeHeartColor() {
        $("body").on("click", ".vr-catalog__icons .vr-catalog__icon", function() {
            var $el = $(this);
            var _clickedHeart = this;

            if(!isLogged){
                if(isViewPage){
                    ga('send', 'event', _gaEventCategory, 'similar-brochure-menu',  $(_clickedHeart).closest(".vr-catalog__bottom").find(".vr-catalog__title_style").text() + "-favourite-button-click-loggedout");
                }else if(isBrandCityPage){
                    ga('send', 'event', _gaEventCategory, 'similar-brochure-old-favourite-button', $(_clickedHeart).closest(".vr-catalog__bottom").find(".vr-catalog__title_style").text() + "-click-loggedout");
                }
            }

            if($el.hasClass('js-add-fav-brand')){
                if($el.hasClass('sh-profile-login') === true){
                    return;
                }
                
                _that = this;
                $el = $el.find('svg');
                _clickedHeart = $el[0];
            }

            var _brandContainerId = $el.data("brand-id"),
                _selectAllBrochuresFromBrand = $(".vr-catalog__icons svg[data-brand-id='"+ _brandContainerId +"']"),
                popupMsg,
                removedFromFav = false,
                svgPath;

            _selectedBrandsArr.push(_brandContainerId);
            if(isLogged){
                /*aj = */$.post("/profile/like_brand", {
                    selectedBrandsArr: _selectedBrandsArr,
                }, function(data) {
                    if ($(_clickedHeart).hasClass('vr-catalog__icon-blue')) {
                        svgPath = "<svg viewBox='0 0 512 512'> <path fill='#babbbb' d='M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z'></path></svg>";
                        popupMsg = "<div class='up-fstores-popup-msg'><div class='up-popup-msg-icon'>" + svgPath + "</div><div class='up-popup-msg-text'><span>" + data.brands[0].msg + "</span></div></div>";
                    } else {
                        svgPath = "<svg viewBox='0 0 512 512'> <path fill='#54a9e2' d='M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z'></path></svg>";
                        popupMsg = "<div class='up-fstores-popup-msg'><div class='up-popup-msg-icon'>" + svgPath + "</div><div class='up-popup-msg-text'><span>" + data.brands[0].msg + "</span></div></div>";
                    }
                    $('.up-popup-msg-container').append(popupMsg);

                    setTimeout(function() {
                        $('.up-popup-msg-container .up-fstores-popup-msg').first().remove();
                    }, 3000);

                    if ($el.attr('class').indexOf("vr-catalog__icon-default") > -1) {
                        _selectAllBrochuresFromBrand.each(function(i){
                                var elClasses = _selectAllBrochuresFromBrand.eq(i).attr('class');

                                elClasses = elClasses.replace('vr-catalog__icon-default', '') + ' vr-catalog__icon-blue ';
                                _selectAllBrochuresFromBrand.eq(i).attr('class', elClasses);

                                // _selectAllBrochuresFromBrand.eq(i).removeClass("vr-catalog__icon-default").addClass("vr-catalog__icon-blue");
                                _selectAllBrochuresFromBrand.eq(i).attr("data-prefix", "fas");
                                //add shadow to vr-catalog
                                _selectAllBrochuresFromBrand.eq(i).closest(".vr-catalog").addClass("vr-catalog_liked");
                        });
                    } else {
                        _selectAllBrochuresFromBrand.each(function(i){
                                var elClasses = _selectAllBrochuresFromBrand.eq(i).attr('class');

                                elClasses = elClasses.replace('vr-catalog__icon-blue', '') + ' vr-catalog__icon-default ';
                                _selectAllBrochuresFromBrand.eq(i).attr('class', elClasses);
                                // _selectAllBrochuresFromBrand.eq(i).removeClass("vr-catalog__icon-blue").addClass("vr-catalog__icon-default");
                                _selectAllBrochuresFromBrand.eq(i).attr("data-prefix", "far");
                                //remove shadow from vr-catalog
                                if (_selectAllBrochuresFromBrand.eq(i).closest(".vr-catalog").hasClass("vr-catalog_liked")) {
                                    _selectAllBrochuresFromBrand.eq(i).closest(".vr-catalog").removeClass("vr-catalog_liked");
                                }
                        });

                        removedFromFav = true;
                    }
                    
                    if(isViewPage){
                        ga('send', 'event', _gaEventCategory, 'similar-brochure-menu',  $(_clickedHeart).closest(".vr-catalog__bottom").find(".vr-catalog__title_style").text() + "-favourite-button-click-loggedin");
                    }else if(isBrandCityPage){
                        ga('send', 'event', _gaEventCategory, 'similar-brochure-old-favourite-button',  $(_clickedHeart).closest(".vr-catalog__bottom").find(".vr-catalog__title_style").text() + (removedFromFav ? 'remove-from-favourites' : "-click-loggedin"));
                    }

                }, "json");
            }
            /*aj.fail(function(e, m, n) {
                console.log(e, m, n)
            })*/

            _selectedBrandsArr = [];

        });
    }

    function _showMoreBrochuresMobile() {
        $("body").on("click", ".vr-related-bottom__btn .vr-related-bottom__btn_inner", function() {
            _showMoreBrochures();

            bLazy.revalidate();
            ga('send', 'event', _gaEventCategory, 'similar-brochure-see-more-button', window.location.href);
        });
    }

    function _showMoreBrochures() {
        _allBrochureSelector = $(".vr-none").not('.brandc-brochures .vr-none');
        var logged_user_class = isLogged ? "" : "sh-profile-login";
        var fav_brand_class;

        if (isMobile) {
            _numberOfAddBrochures = _visibleBrochuresLength;
        } else {
            _numberOfAddBrochures = 5;
        }

        var dataArray = "show_more_related_brochures",
            ajaxUrl = "/brochures/show_more_related_brochures",
            data = { 
                "limit": _numberOfAddBrochures, 
                "category_id": categoryId,
                "brand_id": brandId,
                "page": page_name,
                "brochures_step": _allBrochureSelector.length,
                "city_id": city_id
             };

        if(page_name === "brochure_view"){
            data["brochure_id"] = brochureId;
        }

        $.ajax({
            type: "POST",
            url: ajaxUrl,
            data: data,
            dataType: 'json',
            success: function(data) {
                if(typeof data[dataArray] !== 'undefined' && data[dataArray].length > 0){
                    $.each(data[dataArray], function(i) {
                        
                        fav_brand_class = data[dataArray][i].favorite_brand ? "vr-catalog__icon-blue fas" : "vr-catalog__icon-default far";

                        var brochureIcons ='<div class="vr-catalog__icons"><svg class="' + logged_user_class + ' ' + fav_brand_class + ' fa-heart vr-catalog__icon" data-brand-id="' + data[dataArray][i].brand_id + '" title="' + data[dataArray][i].brand_name + '" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path class="path-default" fill="currentColor" d="M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"></path><path class="path-filled" fill="currentColor" d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"></path></svg></div>';
                        
                        var brochureBottom = '<div class="vr-catalog__bottom"><div class="vr-catalog__title"><a class="vr-catalog__title_style" href="' + data[dataArray][i].brochure_link + '" title="' + data[dataArray][i].brand_name + '">' + data[dataArray][i].brand_name + '</a></div>' + brochureIcons + '</div>';

                        var brochureTemplateDesktop = '<div class="swiper-slide vr-none" data-brochure-id="' + data[dataArray][i].id + '"><article class="vr-catalog"><div class="vr-catalog__cover"><a href="' + data[dataArray][i].brochure_link + '" title="' + data[dataArray][i].brand_name + '"><div class="vr-catalog__image" data-brochure-id="' + data[dataArray][i].id + '" data-offerista-id="' + data[dataArray][i].offerista_id + '"><div class="vr-catalog__border"><img src="' + data[dataArray][i].cover + '"><div class="vr-catalog__mask"><div class="vr-catalog__buttons"><div><span title="' + viewLang.html_see_more + '">' + viewLang.html_see_more + '</span></div></div></div></div></div></a></div>' + brochureBottom + '</article></div>';

                        var brochureTemplateMobile = brochureTemplateDesktop.replace("swiper-slide", " col-xs-6 vr-show");

                        if (data[dataArray][i].favorite_brand === true) {
                            brochureTemplateDesktop = brochureTemplateDesktop.replace('<article class="vr-catalog', '<article class="vr-catalog vr-catalog_liked');
                        }

                        if(page_name === "brand_city"){
                            $(".brandc-similar-bro .fx-row").append(brochureTemplateDesktop);
                        }else{
                            if(isMobile){
                                $(".vr-related-bottom .vr-sw").append(brochureTemplateMobile);
                            }else{
                                //$(".swiper-wrapper").append(brochureTemplate);
                                // if(typeof viewVersion !== 'undefined' && viewVersion === '3'){
                                //     $('.vr-related-bottom__container').append(brochureTemplateDesktop);
                                // }else{
                                //     swiper.appendSlide(brochureTemplateDesktop);
                                // }
                                $(".vr-related-bottom__brochures-wrapper.vr-related-bottom-v4").append(brochureTemplateMobile);
                            }
                        }

                    });
                }

                // if(!isMobile && (typeof data[dataArray] === 'undefined' || data[dataArray].length === 0) && typeof swiper !== 'undefined'){
                //     swiper.slideTo(1, 500, true);
                // }
                
                if (typeof data === 'undefined' || typeof data[dataArray] === 'undefined' || data[dataArray].length < 10) {
                    $(".vr-related-bottom__btn").hide();
                }

                if(!isLogged){
                    $(".vr-catalog__icon").addClass("sh-profile-login");
                }
            },
            error: function(err) {

            }
        });
        _visibleBrochureIds = [];
    }

    function _init() {
        _changeHeartColor();
        _initSlider();
        _showMoreBrochuresMobile();

        if (!isMobile) {
            function debounce(func, wait, immediate) {
                var timeout;
                return function() {
                    var context = this, args = arguments;
                    var later = function() {
                        timeout = null;
                        if (!immediate) func.apply(context, args);
                    };
                    var callNow = immediate && !timeout;
                    clearTimeout(timeout);
                    timeout = setTimeout(later, wait);
                    if (callNow) func.apply(context, args);
                };
            };

            window.addEventListener('scroll', debounce(_showMoreBrochures, 50, true));
        }

        $(document).on("click", ".vr-catalog__cover a", function(){
            if($(this).closest('.vr-mobile-body__banner').length > 0){
                ga('send', 'event', 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'), 'similar-brochure-between-pages', this.href);
            }else{
                ga('send', 'event', _gaEventCategory, (isViewPage ? 'similar-brochure-menu' : (isBrandCityPage ? 'similar-brochure-old-image' : '')),  (isViewPage ? $(this).closest(".vr-catalog").find(".vr-catalog__title_style").text() + "-image-click" : (isBrandCityPage ? this.href : '')));
            }
        });
        $(document).on("click", ".vr-catalog__title_style", function(){
            if(isViewPage){
                if($(this).closest('.vr-mobile-body__banner').length > 0){
                    ga('send', 'event', 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'), 'similar-brochure-between-pages', this.href);
                }else{
                    ga('send', 'event', _gaEventCategory, 'similar-brochure-menu',  $(this).text() + "-text-click");
                }
            }else if(isBrandCityPage){
                ga('send', 'event', _gaEventCategory, 'similar-brochure-old-text',  this.href);
            }
        });
        $(document).on("click", ".vr-related-bottom__arrow svg", function(e) {
            ga('send', 'event', _gaEventCategory, 'similar-brochure-menu',  "slider");
            bLazy.revalidate();
        });
        if(page_name === "brand_city"){
            $("body").on("click", ".brandc-similar-bro .vr-related-bottom__btn button", function(e) {
                e.preventDefault();
                _showMoreBrochures();
                
                if(isBrandCityPage){
                    ga('send', 'event', { eventCategory: _gaEventCategory, eventAction: 'more-similar-brochures-native-button'});
                }
            });
        }

        if(isMobile && $(".vr-related-bottom .vr-banner-mobile").length !== 0){

            function bannerRelatedBrochures(x) {

                var bannerSelector1 = ".vr-related-bottom .vr-banner-related-1";
                var bannerSelector2 = ".vr-related-bottom .vr-banner-related-2";

                var thirdBrochure = $(".vr-related-bottom .vr-none").eq(2);
                var fourthBrochure = $(".vr-related-bottom .vr-none").eq(3);
                var sevenBrochure = $(".vr-related-bottom .vr-none").eq(6);
                var eightBrochure = $(".vr-related-bottom .vr-none").eq(7);
                var nineBrochure = $(".vr-related-bottom .vr-none").eq(8);


                if(two.matches){         // 620      2 on row
                    thirdBrochure.detach();
                    thirdBrochure.insertAfter(bannerSelector1);
                    fourthBrochure.detach();
                    fourthBrochure.insertAfter(bannerSelector1);

                }else if(three.matches){ // 620 - 830      3 on row
                    thirdBrochure.detach();
                    thirdBrochure.insertBefore(bannerSelector1);
                    fourthBrochure.detach();
                    fourthBrochure.insertAfter(bannerSelector1);

                    if(sevenBrochure && eightBrochure && nineBrochure && ($(".vr-banner-related-2").length !== 0)){
                        sevenBrochure.detach();
                        sevenBrochure.insertBefore(bannerSelector2);
                        eightBrochure.detach();
                        eightBrochure.insertBefore(bannerSelector2);
                        nineBrochure.detach();
                        nineBrochure.insertBefore(bannerSelector2);
                    }

                }else{                   //830      4 on row
                    thirdBrochure.detach();
                    fourthBrochure.detach();
                    thirdBrochure.insertBefore(bannerSelector1);
                    fourthBrochure.insertBefore(bannerSelector1);

                    if(sevenBrochure && eightBrochure && nineBrochure && ($(".vr-banner-related-2").length !== 0)){
                        sevenBrochure.detach();
                        sevenBrochure.insertBefore(bannerSelector2);
                        eightBrochure.detach();
                        eightBrochure.insertBefore(bannerSelector2);
                        nineBrochure.detach();
                        nineBrochure.insertAfter(bannerSelector2);
                    }
                }
            }

            var two = window.matchMedia("(max-width: 620px)");
            var three = window.matchMedia("(max-width: 830px)")
            bannerRelatedBrochures(two);
            bannerRelatedBrochures(three);
            two.addListener(bannerRelatedBrochures); 
            three.addListener(bannerRelatedBrochures)
        }

    }

    _init();

    _this.showMoreBrochures = _showMoreBrochures;
    _this.init = _init;
};